<template>
  <div class="customer-logo">
    <div class="customer-logo__wrapper">
      <img
        v-lazy-load
        :data-src="customerLogo.logoSrc"
        alt=""
        class="customer-logo__img"
      >
      <div
        class="customer-logo__description"
        v-html="customerLogo.description"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerLogoItem',
  props: {
    customerLogo: {
      type: Object,
      default: () => null
    }
  }
}
</script>

<style lang="scss">
.customer-logo {
  position: relative;
  height: 64px;

  @media (max-width: $breakpoint-md) {
    position: static;
    height: 100%;
  }
}

.customer-logo__wrapper {
  padding-left: 16px;
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  bottom: 0;
  left: 0;

  flex-direction: column-reverse;
  align-items: flex-start;
  justify-content: space-between;
  background-color: #FFF;
  border: 1px solid rgba(255, 255, 255, 0);
  border-radius: 8px;
  transition: width 0.4s ease, height 0.4s ease;

  @media (max-width: $breakpoint-md) {
    padding-left: 0;
    position: static;
    height: auto;
    flex-direction: row;
    border: none;
  }
}

.customer-logo:hover .customer-logo__wrapper {
  z-index: 2;
  height: 169px;
  top: initial;
  overflow: hidden;

  border: 1px solid rgba($primary, 0.15);

  @media (max-width: $breakpoint-md) {
    position: static;
    height: auto;
    width: 100%;
    border: none;
  }
}

.customer-logo:nth-of-type(4) {
  .customer-logo__wrapper {
    @media (min-width: $breakpoint-lg +1) {
      top: 0;
      flex-direction: column;
    }
  }
}

.customer-logo:nth-of-type(1),
.customer-logo:nth-of-type(2),
.customer-logo:nth-of-type(3) {
  .customer-logo__wrapper {
    @media (min-width: $breakpoint-md +1) {
      top: 0;
      flex-direction: column;
    }
  }
}

.customer-logo__img {
  @media (max-width: $breakpoint-md) {
    max-width: 100%;
  }
}

.customer-logo__description {
  z-index: -1;
  overflow: hidden;
  padding: 16px 16px 16px 0;
  transition: opacity 0.1s ease;
  opacity: 0;

  @media (max-width: $breakpoint-xxl) {
    font-size: 14px;
    line-height: 20px;
  }

  @media (max-width: $breakpoint-md) {
    display: none;
  }
}

.customer-logo:hover .customer-logo__description {
  opacity: 1;
  transition: opacity 0.4s linear;

  @media (max-width: $breakpoint-md) {
    display: none;
  }
}
</style>